'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apply = exports.throttleAll = exports.wrapDispatch = exports.getPageCount = exports.getTotal = exports.getOption = exports.getPage = exports.getRange = exports.getResource = undefined;

var _throttledDispatch = require('./throttled-dispatch');

Object.defineProperty(exports, 'wrapDispatch', {
  enumerable: true,
  get: function get() {
    return _throttledDispatch.wrapDispatch;
  }
});

var _getResource2 = require('./get-resource');

var _getResource3 = _interopRequireDefault(_getResource2);

var _getRange2 = require('./get-range');

var _getRange3 = _interopRequireDefault(_getRange2);

var _getPage2 = require('./get-page');

var _getPage3 = _interopRequireDefault(_getPage2);

var _getOption2 = require('./get-option');

var _getOption3 = _interopRequireDefault(_getOption2);

var _getTotal2 = require('./get-total');

var _getTotal3 = _interopRequireDefault(_getTotal2);

var _getPageCount2 = require('./get-page-count');

var _getPageCount3 = _interopRequireDefault(_getPageCount2);

var _throttleAll2 = require('./throttle-all');

var _throttleAll3 = _interopRequireDefault(_throttleAll2);

var _apply2 = require('./apply');

var _apply3 = _interopRequireDefault(_apply2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getResource = _getResource3.default;
exports.getRange = _getRange3.default;
exports.getPage = _getPage3.default;
exports.getOption = _getOption3.default;
exports.getTotal = _getTotal3.default;
exports.getPageCount = _getPageCount3.default;
exports.throttleAll = _throttleAll3.default;
exports.apply = _apply3.default;